import React, { Component } from "react";

import Dialog   from 'material-ui/Dialog';
import RaisedButton  from "material-ui/RaisedButton";

const styles = {
  filterDialog : {
    width    : '80%',
    maxWidth : 'none'
  }
};

export default class ConfirmDialog extends Component {
    constructor(props) {
        super(props);

        this.state = { }
    }
    
  render() {
      const action = [];

      if(this.props.onCancel)
        action.push(
          <RaisedButton
            label={this.props.cancelLabel}
            primary={false}
            onClick={this.props.onCancel}
          />
        );

      if(this.props.onConfirm)
        action.push(
          <RaisedButton
            label={this.props.confirmLabel}
            primary={true}
            onClick={this.props.onConfirm}
          />
        );

    return(
            <Dialog
                title={this.props.title || ""}
                actions={action}
                autoScrollBodyContent={true}
                modal={true}
                contentStyle={styles.filterDialog}
                open={this.props.opened || false}>
                    {this.props.body}
            </Dialog>
    );
  }
}


// WEBPACK FOOTER //
// ./src/Components/component_ConfirmDialog.js